export enum TypeAnswer {
  SHORT_ANSWER = 'short_answer',
  DETAILED_ANSWER = 'detailed_answer',
  NUMBER = 'number',
  ONE_FROM_LIST = 'one_from_list',
  SEVERAL_FROM_LIST = 'several_from_list',
  SCALE = 'scale',
  GRADE = 'grade',
  EMOTIONS = 'emotions',
  GRID_ONE_ANSWER = 'grid_one_answer',
  GRID_SEVERAL_ASNWER = 'grid_several_answer',
  COMPARISON_PICTURES = 'comparison_pictures',
}

export enum PollsStatuses {
  NEW = 'new',
  NOT_COMPLETED = 'not_completed',
  COMPLETED = 'completed'
}

export enum PollType {
  STEPPER = 'stepper',
  TABS = 'tabs',
  ONE_PAGE = 'one_page'
}

export enum TypeAnserSelect {
  DROP_DOWN_LIST = 'drop_down_list',
  RADIO_BUTTON = 'radio_button',
  CHECKBOX = 'checkbox',
  ANSWER_CLOUD = 'answer_cloud',
}

export const PollsStatusesTranslate: Record<string, string> = {
  [PollsStatuses.NEW]: 'Новый',
  [PollsStatuses.NOT_COMPLETED]: 'Не завершен',
  [PollsStatuses.COMPLETED]: 'Завершен',
};
